import Button from '@mui/material/Button';
import CSVFileValidator from 'csv-file-validator';
import { Component } from 'react';
import { CSVLink } from "react-csv";
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import EinApi from '../../api/eins';
import SampleEin from '../../assets/images/sample-ein.png';
import FileUpload from '../../components/FileUpload';
import { formatDoh, formatTimeType, formatWeeklyHours, getDohFormat } from '../../utils/Formatter';
import { isValidEmail } from '../../utils/Validators';
import { withRouter } from '../../utils/withRouter';
import { EINS_DATA, EINS_HEADER } from './sample-data';
import UploadCensusConfirmationModal from './uploadCensusConfirmationModal';

class AddEins extends Component
{
    defaultConfirmationMessage = 'confirm'

    state = {
        name: '',
        description: '',
        file: null,
        busy: false,
        errors: [],
        einData: [],
        fileName: null,
        files: null,
        confirmEinUpload: false,
        confirmationMessage: '',
        confirmationData: {}
    }

    componentDidMount = () =>
    {
        const { ein } = this.props
        this.setState({ ...ein })
    }

    toBase64 = file => new Promise((resolve, reject) =>
    {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    handleSave = async (e, options = {}) =>
    {
        e.preventDefault();
        this.setState({ busy: true })
        const { name, description, file, einData, errors } = this.state
        const { onCreate, onCancel, showMessage, showError, domainId } = this.props

        if (!name || !description || !file)
        {
            return this.props.showMessage("All fields are required");
        }
        const dateFormat = getDohFormat(einData[0].doh)
        const formattedEinData = einData.map(each => ({
            ...each,
            email: each.user.toLowerCase().trim(),
            doh: formatDoh(each, dateFormat),
            time_type: formatTimeType(each),
            weekly_hours: formatWeeklyHours(each.weekly_hours)
        }))
        if (!errors.length)
        {
            try
            {

                const base64file = await this.toBase64(file);
                let payload = {
                    name,
                    description,
                    einData: formattedEinData,
                    domainId,
                    fileName: file.name,
                    file: base64file,
                    enrollNewHiresInWelcomeSequence: options.enrollNewHiresInWelcomeSequence
                };

                onCancel();

                const confirm = this.state.confirmationMessage === this.defaultConfirmationMessage
                const result = await EinApi.saveEin({ ...payload, confirm })
                if (result)
                {
                    this.setState({ confirmationData: result, confirmEinUpload: true })
                    return
                }
                showMessage('The new Eins has been added. This may take few minutes to reflect depends on data size');

                this.setState({ confirmationMessage: '', confirmationData: {}, confirmEinUpload: false })
                onCreate();
            } catch (err)
            {
                showError()
            } finally
            {
                this.setState({ busy: false })

            }
        } else
        {
            showMessage('Kindly fix the below error message');
        }


    }

    handleOnChange = ({ currentTarget: { name, value } }) => this.setState({ [name]: value })

    getFile = (file, fileName) =>
    {
        this.setState({ errors: [] })
        const config = {
            skipEmptyLines: true,
            headers: [
                {
                    name: 'Email Address',
                    inputName: 'user',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    },
                    validate: function (email)
                    {
                        return isValidEmail(email)
                    },
                    validateError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} in ${rowNumber} row / ${columnNumber} column must be a valid email address`
                    },
                },
                {
                    name: 'Employer Key',
                    inputName: 'employerKey',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Job Title',
                    inputName: 'job_title',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Eins',
                    inputName: 'ein',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'DOH',
                    inputName: 'doh',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Time Type',
                    inputName: 'time_type',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Weekly Hours',
                    inputName: 'weekly_hours',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Location',
                    inputName: 'location',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber)
                    {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                }
            ],
        }

        CSVFileValidator(file, config)
            .then(({ data, inValidData }) =>
            {
                if (!inValidData.length > 0)
                {
                    this.setState({ einData: data, file, fileName, busy: false, errors: [] });
                } else
                {
                    this.setState({ errors: inValidData })
                }
            })
            .catch(err => { this.props.showError(err) })

    }

    render()
    {
        return (
            <div>
                <div>
                    <div className='rows'>
                        <div className='form-group nice'>
                            <label>Ein Name</label>
                            <input
                                disabled={this.state.busy}
                                name='name'
                                value={this.state.name}
                                onChange={this.handleOnChange}
                                type='text'
                                className='form-control'
                                placeholder='Ein Name (Alphanumeric, Ex: January-Ein)'
                            />
                        </div>
                        <div className='form-group nice'>
                            <label>Ein Description</label>
                            <input
                                disabled={this.state.busy}
                                name='description'
                                value={this.state.description}
                                onChange={this.handleOnChange}
                                type='text'
                                className='form-control'
                                placeholder='Description of the ein Name for internal use'
                            />
                        </div>
                        <div className='form-group nice'>
                            <label>Upload Ein</label>
                            <FileUpload
                                needProccess={true}
                                getFile={this.getFile}
                                onError={this.props.showError}
                                onUpload={() => { }}
                                onChange={(file) => this.setState({ file })}
                                value={this.state.fileName}
                                disabled={this.state.busy}
                                name='file'
                                accept='.csv'
                                label='Select Ein File...'
                            />
                        </div>
                    </div>

                    {this.state.errors.map((error) => (<div className="alert alert-info"> <span>{error.message}</span> </div>))}

                    <div className='row' style={{ display: "flex", gap: "40px", justifyContent: "center", alignItems: "center" }}>
                        <div>
                            <div className='line-break' />
                            <button
                                className='btn btn-primary loading'
                                disabled={this.state.busy}
                                onClick={this.handleSave}
                            >
                                Add Ein
                            </button>
                        </div>

                        <div className='margin-top-13'>
                            <CSVLink data={EINS_DATA} filename="Sample_Eins.csv" heaaders={EINS_HEADER}>
                                <Button color="primary">Download Sample Eins</Button>
                            </CSVLink>
                        </div>
                    </div>

                    <img src={SampleEin} alt='SampleEin' style={{ maxWidth: "100%", width: "100%", marginTop: "50px" }} />
                </div>
                {this.state.confirmEinUpload && this.state.confirmationData &&
                    <UploadCensusConfirmationModal
                        onCancel={() => this.setState({ confirmEinUpload: false })}
                        disabled={this.state.busy || this.defaultConfirmationMessage !== this.state.confirmationMessage}
                        action={this.handleSave}
                        data={this.state.confirmationData}
                        confirmationMessage={this.state.confirmationMessage}
                        setConfirmationMessage={(message) => this.setState({ confirmationMessage: message })}
                    />}

            </div>
        )
    }
}
export default withRouter(connect(null, { showMessage, showError, confirmAction })(AddEins));
